import { buildBaseProps, buildScoresData } from "../../helpers";
var NumberOfParts;
(function (NumberOfParts) {
    NumberOfParts[NumberOfParts["TwoParts"] = 2] = "TwoParts";
    NumberOfParts[NumberOfParts["FourParts"] = 4] = "FourParts";
})(NumberOfParts || (NumberOfParts = {}));
const twoPartsScoreKeys = [
    { header: "FirstHalfHeader", team1Key: "basketballFirstHalfScore1", team2Key: "basketballFirstHalfScore2", translatable: true, gamePart: "FirstHalf" },
    { header: "SecondHalfHeader", team1Key: "basketballSecondHalfScore1", team2Key: "basketballSecondHalfScore2", translatable: true, gamePart: "SecondHalf" }
];
const fourPartsScoreKeys = [
    { header: "FirstQuarterHeader", team1Key: "basketballFirstQuarterScore1", team2Key: "basketballFirstQuarterScore2", translatable: true, gamePart: "FirstQuarter" },
    { header: "SecondQuarterHeader", team1Key: "basketballSecondQuarterScore1", team2Key: "basketballSecondQuarterScore2", translatable: true, gamePart: "SecondQuarter" },
    { header: "HalfTimeHeader", team1Key: "basketballFirstHalfScore1", team2Key: "basketballFirstHalfScore2", translatable: true, gamePart: "FirstQuarter" },
    { header: "ThirdQuarterHeader", team1Key: "basketballThirdQuarterScore1", team2Key: "basketballThirdQuarterScore2", translatable: true, gamePart: "ThirdQuarter" },
    { header: "FourthQuarterHeader", team1Key: "basketballFourthQuarterScore1", team2Key: "basketballFourthQuarterScore2", translatable: true, gamePart: "FourthQuarter" }
];
const scoreKeys = {
    0: {
        [NumberOfParts.TwoParts]: [
            ...twoPartsScoreKeys,
            { header: "DefaultPoints", team1Key: "homeScore", team2Key: "awayScore", translatable: true, gamePart: "" }
        ],
        [NumberOfParts.FourParts]: [
            ...fourPartsScoreKeys,
            { header: "DefaultPoints", team1Key: "homeScore", team2Key: "awayScore", translatable: true, gamePart: "" }
        ]
    },
    ["FirstOvertime"]: {
        [NumberOfParts.TwoParts]: [
            ...twoPartsScoreKeys,
            { header: "OvertimeHeader", team1Key: "basketballOverTimeScore1", team2Key: "basketballOverTimeScore2", translatable: true, gamePart: "FirstOvertime" },
            { header: "DefaultPoints", team1Key: "homeScore", team2Key: "awayScore", translatable: true, gamePart: "" }
        ],
        [NumberOfParts.FourParts]: [
            ...fourPartsScoreKeys,
            { header: "OvertimeHeader", team1Key: "basketballOverTimeScore1", team2Key: "basketballOverTimeScore2", translatable: true, gamePart: "FirstOvertime" },
            { header: "DefaultPoints", team1Key: "homeScore", team2Key: "awayScore", translatable: true, gamePart: "" }
        ]
    },
    ["SecondOvertime"]: {
        [NumberOfParts.TwoParts]: [
            ...twoPartsScoreKeys,
            { header: "SecondOvertimeHeader", team1Key: "basketballOverTimeScore1", team2Key: "basketballOverTimeScore2", translatable: true, gamePart: "SecondOvertime" },
            { header: "DefaultPoints", team1Key: "homeScore", team2Key: "awayScore", translatable: true, gamePart: "" }
        ],
        [NumberOfParts.FourParts]: [
            ...fourPartsScoreKeys,
            { header: "SecondOvertimeHeader", team1Key: "basketballOverTimeScore1", team2Key: "basketballOverTimeScore2", translatable: true, gamePart: "SecondOvertime" },
            { header: "DefaultPoints", team1Key: "homeScore", team2Key: "awayScore", translatable: true, gamePart: "" }
        ]
    },
    ["Finished"]: {
        [NumberOfParts.TwoParts]: [
            ...twoPartsScoreKeys,
            { header: "OvertimeHeader", team1Key: "basketballOverTimeScore1", team2Key: "basketballOverTimeScore2", translatable: true, gamePart: "Finished" },
            { header: "DefaultPoints", team1Key: "homeScore", team2Key: "awayScore", translatable: true, gamePart: "" }
        ],
        [NumberOfParts.FourParts]: [
            ...fourPartsScoreKeys,
            { header: "OvertimeHeader", team1Key: "basketballOverTimeScore1", team2Key: "basketballOverTimeScore2", translatable: true, gamePart: "Finished" },
            { header: "DefaultPoints", team1Key: "homeScore", team2Key: "awayScore", translatable: true, gamePart: "" }
        ]
    }
};
export const buildBasketballLiveMobileProps = (event, config) => {
    const gamePart = event.liveGameState.gamePart || "0";
    const scores = scoreKeys[gamePart] || scoreKeys["0"];
    const scoresData = buildScoresData(event, scores[event.numberOfParts || NumberOfParts.FourParts], config);
    return Object.assign(Object.assign({}, buildBaseProps(event, config.dict)), { team1Scores: scoresData.team1Scores, team2Scores: scoresData.team2Scores, header: scoresData.headers, liveGameState: event.liveGameState });
};
//# sourceMappingURL=buildBasketballLiveMobileProps.js.map